import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { Client } from '@microsoft/microsoft-graph-client';
//import "@microsoft/microsoft-graph-client/authentication/msalBrowser";

function getInitials(name) {
  if (!name) return '?';
  const parts = name.split(' ');
  return parts.map(p => p[0]).join('').toUpperCase().slice(0, 2);
}

const UserAvatar = () => {
  const { accounts, instance } = useMsal();
  const [photoUrl, setPhotoUrl] = useState(null);
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    const fetchPhoto = async () => {
      if (!accounts || accounts.length === 0) return;
      const account = accounts[0];
      const accessToken = await instance.acquireTokenSilent({ ...loginRequest, account });
      const client = Client.initWithMiddleware({
        authProvider: {
          getAccessToken: async () => accessToken.accessToken,
        },
      });
      try {
        // Get user profile
        const user = await client.api('/me').get();
        setDisplayName(user.displayName || '');
        // Get user photo
        const photoBlob = await client.api('/me/photo/$value').get();
        const url = URL.createObjectURL(photoBlob);
        setPhotoUrl(url);
      } catch (err) {
        setPhotoUrl(null);
      }
    };
    fetchPhoto();
    // Cleanup URL object on unmount
    return () => { if (photoUrl) URL.revokeObjectURL(photoUrl); };
    // eslint-disable-next-line
  }, [accounts, instance]);

  if (!accounts || accounts.length === 0) return null;

  return (
    <div className="user-avatar" title={displayName}>
      {photoUrl ? (
        <img src={photoUrl} alt="User avatar" className="user-avatar-img" />
      ) : (
        <span className="user-avatar-fallback">{getInitials(displayName || accounts[0].name)}</span>
      )}
    </div>
  );
};

export default UserAvatar; 